import styled from "styled-components"
import { MenuListStyles, MenuWrapperStyles } from "./menu-styles"

export const MenuList = styled.ul`
  display: flex;
  ${MenuListStyles}
`

export const MenuWrapper = styled.nav`
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  ${MenuWrapperStyles}
`
